import ProxyModalWithBodyDesc from './ProxyModalWithBodyDesc'
import VerifyCodeOnly from './ModalContentImplementationTemplates/VerifyCodeOnly'
import VerifyCodeByPhone from './ModalContentImplementationTemplates/VerifyCodeByPhone'
import VerifyCodeByNewPhone from './ModalContentImplementationTemplates/VerifyCodeByNewPhone'
import VerifyCodeByNewEmail from './ModalContentImplementationTemplates/VerifyCodeByNewEmail'

export default ProxyModalWithBodyDesc
export {
  VerifyCodeOnly, VerifyCodeByPhone, VerifyCodeByNewPhone, VerifyCodeByNewEmail,
}
